const STORAGE_KEY = 'mf_locale';

/**
 * Every access is guarded because `localStorage` throws outright in Safari
 * private mode and with site data blocked, and a cache miss must never be what
 * stops someone signing in.
 */
export function readCachedLocale(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function writeCachedLocale(code: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, code);
  } catch {
    // Nothing to do: the user record is the durable copy.
  }
}

export function clearCachedLocale(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // See writeCachedLocale.
  }
}
